import React, { Suspense } from 'react'
import { Route, Switch } from 'react-router'

import { AppRoute } from '@Types/inner/AppRoute'

type Props = {
  layout: any
  routes: AppRoute<any>[]
}
const Layout: React.FC<Props> = ({ layout: LayoutComponent, routes }: Props) => {
  return (
    <LayoutComponent>
      <Suspense fallback={null}>
        <Switch>
          {routes.map((route, key) => {
            return <Route key={key} exact={route.exact} path={route.path} component={route.component} />
          })}
        </Switch>
      </Suspense>
    </LayoutComponent>
  )
}

export default Layout
